"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _CheckOutlined = _interopRequireDefault(require("@ant-design/icons/CheckOutlined"));
var _CopyOutlined = _interopRequireDefault(require("@ant-design/icons/CopyOutlined"));
var _LoadingOutlined = _interopRequireDefault(require("@ant-design/icons/LoadingOutlined"));
var _classnames = _interopRequireDefault(require("classnames"));
var _tooltip = _interopRequireDefault(require("../../tooltip"));
var _util = require("./util");
var CopyBtn = function CopyBtn(_ref) {
  var prefixCls = _ref.prefixCls,
    copied = _ref.copied,
    locale = _ref.locale,
    iconOnly = _ref.iconOnly,
    tooltips = _ref.tooltips,
    icon = _ref.icon,
    tabIndex = _ref.tabIndex,
    onCopy = _ref.onCopy,
    btnLoading = _ref.loading;
  var tooltipNodes = (0, _util.toList)(tooltips);
  var iconNodes = (0, _util.toList)(icon);
  var _ref2 = locale !== null && locale !== void 0 ? locale : {},
    copiedText = _ref2.copied,
    copyText = _ref2.copy;
  var systemStr = copied ? copiedText : copyText;
  var copyTitle = (0, _util.getNode)(tooltipNodes[copied ? 1 : 0], systemStr);
  var ariaLabel = typeof copyTitle === 'string' ? copyTitle : systemStr;
  return /*#__PURE__*/React.createElement(_tooltip["default"], {
    title: copyTitle
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: (0, _classnames["default"])("".concat(prefixCls, "-copy"), _defineProperty(_defineProperty({}, "".concat(prefixCls, "-copy-success"), copied), "".concat(prefixCls, "-copy-icon-only"), iconOnly)),
    onClick: onCopy,
    "aria-label": ariaLabel,
    tabIndex: tabIndex
  }, copied ? (0, _util.getNode)(iconNodes[1], /*#__PURE__*/React.createElement(_CheckOutlined["default"], null), true) : (0, _util.getNode)(iconNodes[0], btnLoading ? /*#__PURE__*/React.createElement(_LoadingOutlined["default"], null) : /*#__PURE__*/React.createElement(_CopyOutlined["default"], null), true)));
};
var _default = exports["default"] = CopyBtn;